import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-rewatch-dialog',
  templateUrl: './rewatch-dialog.component.html',
  styleUrls: ['./rewatch-dialog.component.css']
})
export class RewatchDialogComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<RewatchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data : any,
  ) { }

  ngOnInit(): void {
  }

}
